export default {
  greetings:
    '<span class="text -title-1 -black' +
    ' color-secondary--600">H</span>ello!',
  onboarding: {
    player: {
      step1: {
        title: 'Destaque coro',
        text: 'Destaque a tarefa na letra da música',
      },
      step2: {
        title: 'História/Traduções',
        text: 'Descubra a história e os significados da música e as traduções',
      },
    },
  },
  cookies: {
    text:
      'Este aplicativo usa cookies para monitorar seu tráfego. Isso é totalmente opcional, pois' +
      ' não alterará o uso do aplicativo. Ao clicar em Aceitar, você concorda em nos deixar usá-los.',
    dismiss: 'Recusar',
    confirm: 'Aceitar',
    readMore: 'Leia mais',
  },
  pwaUpdate: {
    offlineReady: 'Aplicativo pronto para trabalhar offline',
    updateReady: 'Nova versão disponível!',
    dimsiss: 'Fechar',
    reload: 'Recarregar',
  },
  homePlaceholder: {
    title: 'Pronto para cantar?',
    subtitle: 'Selecione uma música à esquerda e comece!',
  },
  offlineScreen: {
    title: 'Nenhuma conexão com a Internet encontrada',
    description:
      ' Parece que há um problema com sua conexão.<br />' +
      'Verifique sua rede',
    button: 'Tente novamente',
  },
  pwaInstall: {
    text: 'Para uma melhor experiência do usuário<br />Adicione o aplicativo à sua tela inicial :)',
    descartar: 'Agora não',
    instalar: 'Instalar',
    appleDeviceMessage:
      'Para dispositivos Apple, vá para Opções de compartilhamento -> Adicionar a' +
      'tela inicial',
  },
  common: {
    notFound: 'Nenhuma música encontrada :(',
    backButton: 'Voltar',
    backPlayer: 'Jogador',
    comingSoon: 'Em breve',
    unknownArtist: 'Desconhecido',
  },
  search: {
    placeholder: 'Que música você quer cantar?',
    filters: {
      LADAINHA: 'Ladainha',
      CORREDO: 'Corrido',
      MACULELE: 'Maculele',
      SAMBA_DE_RODA: 'Samba de roda',
      TOQUES: 'Toques',
      QUADRA: 'Quadra',
      LOUVACAO: 'Louvaçao',
      CHULAS: 'Chulas',
      SAMBA: 'Samba',
      OTHERS: 'Outros',
      MESTRES: 'Mestres',
      SLAVERY: 'Escravidão',
      ABOUT_CAPOEIRA: 'Sobre a Capoeira',
      START_OF_RODA: 'Início da roda',
      END_OF_RODA: 'Fim da roda',
      LEGENDARY_CHARACTERS: 'Personagens',
      OTHER: 'Outro',
    },
  },
  songList: {
    title: '<span class="color-secondary--600">C</span>anções',
    notFound: {
      title: 'Música não encontrada :(',
      message:
        "Redefina sua pesquisa ou <span class='color-primary--600'>envie-nos uma nova música</span>!",
    },
    error: {
      title: 'Ocorreu um erro :(',
      message: 'Tente recarregar o aplicativo',
    },
    loading: 'Carregando',
  },
  songDetails: {
    translate: 'Tradução',
    history: 'Por trás da música',
  },
  sidebars: {
    filters: {
      title: 'Filtros',
      apply: 'Aplicar filtros',
      genres: {
        title: 'Generos',
        LADAINHA: 'Ladainha',
        CORREDO: 'Corrido',
        MACULELE: 'Maculele',
        SAMBA_DE_RODA: 'Samba de roda',
        TOQUES: 'Toques',
        QUADRA: 'Quadra',
        LOUVACAO: 'Louvaçao',
        CHULAS: 'Chulas',
        SAMBA: 'Samba',
        OTHERS: 'Outros',
      },
      themes: {
        title: 'Temas',
        MESTRES: 'Mestres',
        SLAVERY: 'Escravidão',
        ABOUT_CAPOEIRA: 'Sobre a Capoeira',
        START_OF_RODA: 'Início da roda',
        END_OF_RODA: 'Fim da roda',
        LEGENDARY_CHARACTERS: 'Personagens',
        OTHER: 'Outro',
      },
    },
    favourite: {
      title: 'Sua seleção',
      notFound: 'Músicas não encontradas :(',
      notFoundDetails: 'Adicione alguns aos seus favoritos!',
    },
    settings: {
      title: 'Configurações',
      languages: {
        title: 'Línguas',
        fr: 'Francês',
        en: 'Inglês',
        pt: 'Português',
      },
      theme: 'Tema',
      notifications: 'Notificações',
      kofiLabel: 'Apoie-me no Ko-fi!',
      controls: {
        space: 'Reproduzir/Pausar',
        songDetails: 'Exibir detalhes da música',
        HighlightCoro: 'Destaque Coro',
        incProgress: 'Aumentar o progresso do jogador',
        decProgress: 'Diminuir o progresso do jogador',
        close: 'Sair do jogador',
        settings: 'Abrir Configurações',
        favourite: 'Abrir músicas favoritas',
        theme: 'Alternar tema',
        prevSong: 'Anterior',
        nextSong: 'Next',
      },
    },
  },
  notificationModal: {
    title: 'Fique atualizado com nossas últimas músicas',
    description:
      'Ative as notificações e nós te manteremos informado sobre todas as novidades musicais.',
    perk_1:
      '<span class="color-secondary--600 -bold">Receba notificações instantâneas</span> quando' +
      ' adicionarmos novas músicas' +
      ' à nossa biblioteca.',
    perk_2:
      '<span class="color-secondary--600 -bold">Não perca o ritmo</span> com atualizações oportunas.',
    disclaimer:
      'Você pode ativar ou desativar as notificações a qualquer momento nas configurações.',
    dismiss: 'Recusar',
    confirm: 'Aceitar',
  },
  popups: {
    notification: {
      activated: 'Notificações ativadas',
      deactivated: 'Notificações desativadas',
      manualActivation: 'Você pode ativar as notificações nas configurações.',
    },
    errors: {
      songFetch: 'Ocorreu um erro.',
    },
  },
  share: {
    title: 'Compartilhar o aplicativo',
    button: 'Compartilhar',
    action: {
      text: 'Quer aprender um pouco de Música de Capoeira? Dá uma olhada no Focamu!',
    },
    heading: 'Compartilhe o aplicativo e expanda nosso império. Mwahahah.',
    copy: 'Copie o link :: https://focamu.com',
    copied: 'Link copiado!',
  },
  support: {
    button: 'Suporte',
    title: 'Suporte',
    heading:
      'Tendo um problema? Quer que adicionemos alguma música? Escreva sua solicitação abaixo',
    textarea: {
      placeholder: 'Diga-nos :)',
    },
    options: {
      default: ':: Selecione o assunto ::',
      technical: 'Problema técnico',
      request: 'Pedido de música',
      typo: 'letras / tradução / história / erro de digitação errados',
      contribute: 'Contribuir',
      feature: 'Solicitação de recurso',
      feedback: 'Ou apenas algum feedback',
    },
    buttons: {
      cancel: 'Cancelar',
      submit: 'Enviar',
    },
  },
  mentions: {
    button: 'Menções especiais',
    title: 'Recursos e menções',
    appDev: 'Desenvolvimento de aplicativos',
    stackLib: 'Pilha / Bibliotecas',
    lyricsTrad: 'Letras / Traduções / História',
    musicSOurces: 'Música e análise de letras',
  },
}
